/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const PaginationContainer = styled.div({
  padding: `${gridSize()}px 0`,
});

export const Section = styled.section({
  marginBottom: `${gridSize() * 4}px`,
});
